import React from 'react';
import { Link } from 'react-router-dom';

export default function WordmarkLogo({ size = 18, linkTo = '/', onClick }) {
  const content = (
    <span style={{
      display: 'inline-flex', alignItems: 'baseline',
      letterSpacing: '-0.045em', lineHeight: 1, userSelect: 'none',
      textDecoration: 'none',
    }}>
      <span style={{ fontWeight: 300, fontSize: size, color: 'var(--fg)' }}>cyber</span>
      <span style={{ fontWeight: 700, fontSize: size, color: 'var(--fg)' }}>nate</span>
      <span style={{
        fontWeight: 500, fontSize: size * 0.54,
        color: 'var(--accent)', marginLeft: 1.5,
        letterSpacing: '0.01em',
        alignSelf: 'flex-end', paddingBottom: '0.14em',
      }}>.ai</span>
    </span>
  );

  if (!linkTo) return content;
  return (
    <Link to={linkTo} onClick={onClick} style={{ textDecoration: 'none', display: 'inline-flex' }}>
      {content}
    </Link>
  );
}
